import { z } from 'zod';

export const latestRemttanceMetricSchema = z.object({
  filename: z.string(),
  parsedAt: z.string(),
  totalFeeAssessed: z.string().nullable(),
  claimCount: z.number(),
});

export const latestSubmissionMetricSchema = z.object({
  filename: z.string(),
  submittedAt: z.string(),
  totalAmount: z.string().nullable(),
  status: z.string(),
  claimCount: z.number(),
});

export const providerClaimMetricSchema = z.object({
  providerID: z.guid(),
  firstName: z.string(),
  lastName: z.string(),
  count: z.number(),
});

export const siteMetricsResultSchema = z.object({
  agingClaims: z.number(),
  agingClaimProviders: z.array(providerClaimMetricSchema),
  errorClaims: z.number(),
  errorClaimProviders: z.array(providerClaimMetricSchema),
  latestRemittance: latestRemttanceMetricSchema.nullable(),
  latestSubmission: latestSubmissionMetricSchema.nullable(),
});

export type SiteMetricsResult = z.infer<typeof siteMetricsResultSchema>;

export const isSiteMetricsResult = (obj: any): obj is SiteMetricsResult => {
  return siteMetricsResultSchema.safeParse(obj).success;
};
